import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';
import Backdrop from '@mui/material/Backdrop';

interface WithSpinnerProps {
  loading: boolean;
}

interface SpinnerContainerProps {
  containerStyles?: React.CSSProperties;
}

const SpinnerContainer = styled.div`
  /* text-align: center; */
`;

export const Spinner: React.FC<WithSpinnerProps & SpinnerContainerProps> = ({ containerStyles, ...props }) => (
  <SpinnerContainer style={{ ...containerStyles }}>
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={props.loading}>
      <CircularProgress color='inherit' />
    </Backdrop>
  </SpinnerContainer>
);

export const withLoading =
  <P extends object>(Component: React.ComponentType<P>): React.FC<P & WithSpinnerProps> =>
  ({ loading, ...props }: WithSpinnerProps) =>
    loading ? <Spinner loading={loading} /> : <Component {...(props as P)} />;
